// export LeftMenu from './LeftMenu';
// export TopMenu from './TopMenu';
// export Tabs from './Tabs';
// export PortalTabItem from './PortalTabItem';
import * as SystemSetting from '../system-setting'
import * as AccountCenter from '../account-center'
import * as BusinessJurisdiction from '../BusinessJurisdiction' // 业务权限设置
import * as Home from '../home'
import * as UserDefineArchives from '../UserDefineArchives'

const PortalComponents = {
  'system-setting': SystemSetting,
  'account-center': AccountCenter,
  'BusinessJurisdiction': BusinessJurisdiction,
  'home': Home,
  'UserDefineArchives': UserDefineArchives
}

export default PortalComponents



// WEBPACK FOOTER //
// ./src/common/components/portal/index.jsx